import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-clone-template',
  templateUrl: './clone-template.component.html',
  styleUrls: ['./clone-template.component.scss']
})
export class CloneTemplateComponent implements OnInit {

  copyOf: string = "";
  rename: string = "";
  errorMessage: string = "";
  newForm: Boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CloneTemplateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {}
  ) { }

  ngOnInit() {
    this.copyOf = this.data['copyOf'];
    this.newForm = this.data['newForm'];
  }
  
  onClose() {
    this.dialogRef.close();
  }

  onNoClick() {
    this.dialogRef.close();
  }

  cloneTemplate() {
    if (this.rename.length === 0) {
      this.errorMessage = "Please enter a valid form name.";
      return;
    }
    this.dialogRef.close({ rename: true, value: this.rename });
  }

  onValueChange(value) {
    this.errorMessage = "";
    this.rename = value;
  }
}
